// Campus photo for /colleges/virginia-tech: CC BY 3.0, by Eric T Gunther, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AVirginia_Tech_Burruss_Hall_from_Drillfield.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/virginia-tech/; credited under the photo.
const photo = {
    "slug": "virginia-tech",
    "alt": "Burruss Hall seen across the Drillfield at Virginia Tech in Blacksburg, Virginia",
    "src": "/colleges/virginia-tech/campus-1600.webp",
    "srcSmall": "/colleges/virginia-tech/campus-800.webp",
    "srcMid": "/colleges/virginia-tech/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/virginia-tech/og.jpg",
    "title": "Virginia Tech Burruss Hall from Drillfield",
    "author": "Eric T Gunther",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AVirginia_Tech_Burruss_Hall_from_Drillfield.JPG",
    "read": "2026-10-01"
};

export default photo;
